import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {

    GetTransactionDistributionLevel({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/TransactionOrder/GetTransactionDistributionLevel',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    CancelTransactionOrderVue({commit},payload)
    {
        return new Promise((resolve,reject) => {
            api.post('/TransactionOrder/CancelTransactionOrderVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });

    },
    GetRechargeRecord({commit},payload)
    {
        return new Promise((resolve,reject) => {
            api.get('/TransactionOrder/GetRechargeRecord',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    }
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}